import { Cartographic, CesiumTerrainProvider, IonResource, sampleTerrainMostDetailed } from 'cesium';

const CESIUM_TOKEN = import.meta.env.VITE_CESIUM_TOKEN as string;
// Cesium World Terrain, the terrain the 3D viewer switches to for underground views
const WORLD_TERRAIN_ASSET_ID = 1;
const SAMPLE_TIMEOUT_MS = 8000;

let terrainProvider: Promise<CesiumTerrainProvider> | null = null;

// The token is passed explicitly: the upload dialog can open before any viewer has set Ion's default.
const getTerrainProvider = () => {
	terrainProvider ??= CesiumTerrainProvider.fromUrl(
		IonResource.fromAssetId(WORLD_TERRAIN_ASSET_ID, { accessToken: CESIUM_TOKEN }),
	);
	return terrainProvider;
};

/**
 * Ground height at a WGS84 position, in metres above the ellipsoid (the height reference the
 * app stores), sampled from Cesium World Terrain. Null when it cannot be determined in time.
 */
export async function sampleGroundHeight(lon: number, lat: number): Promise<number | null> {
	const sample = getTerrainProvider()
		.then((provider) => sampleTerrainMostDetailed(provider, [Cartographic.fromDegrees(lon, lat)]))
		.then(([position]) => (Number.isFinite(position?.height) ? Math.round(position.height * 100) / 100 : null))
		.catch((error: unknown) => {
			terrainProvider = null; // build it again on the next call
			console.warn('Could not sample the ground height', error);
			return null;
		});

	let timer: ReturnType<typeof setTimeout> | undefined;
	const timeout = new Promise<null>((resolve) => {
		timer = setTimeout(() => resolve(null), SAMPLE_TIMEOUT_MS);
	});
	const height = await Promise.race([sample, timeout]);
	clearTimeout(timer);
	return height;
}
